import React, { useState, useEffect } from "react";
import { FaEnvelope, FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import apis from "../services";
import { useDispatch } from "react-redux";
import { setUser } from "../redux/userSlice";
import { SyncLoader } from "react-spinners";

function Login() {
  const navigate = useNavigate();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    const savedPassword = localStorage.getItem("rememberedPassword");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
    if (savedPassword) {
      setPassword(savedPassword);
    }
  }, []);

  const togglePasswordVisibility = () => setPasswordVisible((v) => !v);

  const handleRememberMeChange = (e) => setRememberMe(e.target.checked);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {

  let deviceId = localStorage.getItem('deviceId');
      console.log("first", deviceId)
    if (!deviceId) {
      deviceId = crypto.randomUUID();
      localStorage.setItem('deviceId', deviceId);
            console.log("second", deviceId)
    }

      const body = { email, password , deviceId};


      const response = await apis.authLogin(body);

      dispatch(setUser(response.data.user));

      if (response?.data?.user?._id) {
        if (rememberMe) {
          localStorage.setItem("rememberedEmail", email);
        } else {
          localStorage.removeItem("rememberedEmail");
          localStorage.removeItem("rememberedPassword");
        }

        localStorage.setItem("userId", response.data.user._id);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        toast.success("User login successfully");

        setTimeout(() => {
          setLoading(false);
          if (response?.data?.status) {
            navigate("/home");
          }
        }, 1000);
      } else {
        setLoading(false);
        toast.error("User ID not found in response data");
      }
    } catch (error) {
      setLoading(false);
      if (
        error.response &&
        (error.response.status === 500 || error.response.status === 404)
      ) {
        toast.error("Invalid Credentials");
      } else {
        toast.error(
          error.response?.data?.message ||
            "Something went wrong, please try again"
        );
      }
    }
  };

  return (
    <div className="login-background">
      <div className="header-container">
        <div className="header-content">
          <h2 className="header-subtitle">
            <span className="color-sp-lookna"> Lookna </span>
            <br></br>
            <br></br>
            FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
          </h2>
        </div>
        <div className="details-borders"></div>
      </div>
      <div style={{ height: "90px" }}></div>
      <div className="login-box">
        <h2 className="login-title">LOGIN ACCOUNT</h2>
        <form className="login-form" onSubmit={handleLogin}>
          {/* Email */}
          <label className="input-label">Email</label>
          <div className="input-group">
            <input
              type="email"
              placeholder="Lorem@Gmail.Com"
              className="input-field"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <FaEnvelope className="input-icon" />
          </div>
          {/* Password + Forgot */}
          <div className="password-row">
            <label className="input-label">Password</label>
          </div>
          <div className="input-group">
            <input
              type={passwordVisible ? "text" : "password"}
              placeholder="Enter Your Password"
              className="input-field"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className="input-icon password-toggle"
              onClick={togglePasswordVisibility}
            >
              {passwordVisible ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          <div className="password-row">
            <label className="input-label"></label>
            <span
              className="forgot-link"
              onClick={() => navigate("/forgot-password")}
              tabIndex={0}
            >
              Forgot Password ?
            </span>
          </div>
          <button
            className="login-btn"
            type="submit"
            disabled={loading}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              cursor: loading ? "not-allowed" : "pointer",
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? <SyncLoader color="white" size={9} /> : "Login Now"}
          </button>
        </form>
        <div className="login-footer">
          Don’t Have An Account?{" "}
          <span className="signup-link" onClick={() => navigate("/signup")}>
            Sign Up
          </span>
        </div>
      </div>
    </div>
  );
}

export default Login;
